/*
  XAND viewport metrics.

  Publishes the live height of the sticky chrome onto <html> as CSS custom
  properties, and flags the body once the page has scrolled off the top.

    --marquee-height   height of the marquee banner, 0 when it is absent
    --header-height    height of the header. Dawn sets this too, but only on
                       load and on a single media-query change, so it goes
                       stale as soon as the window is resized.

  Every number here is measured rather than typed, which is the whole point: a
  wrapping nav or a second line of marquee text re-fits the hero instead of
  leaving it a few pixels short.
*/
(function () {
  var root = document.documentElement;
  var observers = [];

  function publish(name, px) {
    root.style.setProperty(name, px.toFixed(2) + 'px');
  }

  function track(selector, name) {
    var el = document.querySelector(selector);

    if (!el) {
      publish(name, 0);
      return;
    }

    // offsetHeight rather than getBoundingClientRect: the header is translated
    // while it hides on scroll, and we want its layout height, not its visual
    // one. A transform would otherwise feed a moving number back into the hero.
    function write() {
      publish(name, el.offsetHeight);
    }

    write();

    if (window.ResizeObserver) {
      var observer = new ResizeObserver(write);
      observer.observe(el);
      observers.push(observer);
    } else {
      window.addEventListener('resize', write);
    }
  }

  function measure() {
    observers.forEach(function (observer) {
      observer.disconnect();
    });
    observers = [];

    track('.marquee-banner', '--marquee-height');
    track('.section-header', '--header-height');
  }

  measure();

  // The theme editor swaps section markup in place, which throws away whatever
  // we were observing. Re-measure whenever that happens.
  document.addEventListener('shopify:section:load', measure);
  document.addEventListener('shopify:section:unload', measure);

  /*
    Solid-on-scroll flag for the transparent header.

    A 1px sentinel sitting just below the top of the document, watched by an
    IntersectionObserver. When it leaves the viewport the header goes solid,
    when it comes back the header goes transparent again.

    Deliberately not a scroll listener. This fires on the two crossings rather
    than on every frame of every scroll, and it cannot drift out of sync the
    way a cached scroll offset can.
  */
  var sentinel = document.createElement('span');
  sentinel.id = 'header-scroll-tracker';
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText =
    'position:absolute;top:var(--header-scroll-tracker-offset, 20px);' +
    'left:0;width:1px;height:1px;pointer-events:none;';
  document.body.prepend(sentinel);

  new IntersectionObserver(function (entries) {
    document.body.classList.toggle('header-is-solid', !entries[0].isIntersecting);
  }).observe(sentinel);
})();
